<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Compras</h1>
          <p class="view-header__subtitle">Gestioná los comprobantes de compra de la sucursal.</p>
        </div>
        <div class="view-header__actions">
          <router-link :to="nuevaCompraLink" class="btn view-header__btn view-header__btn--primary">
            <i class="bi bi-plus-lg"></i>
            Nueva compra
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="purchases = null">
      <div class="row" style="margin-top:10vh;">
        <div class="col-md-5 col-md-offset-2 text-center">
          <h2>Pasá todas tus compras, es facil!</h2>
          <p style="padding:10px 35px 10px; margin:0; font-size:15px"><b>Antes de empezar, no te olvides de cargar tus <router-link :to="indexInventarioLink">productos</router-link> y <router-link :to="indexProveedoresLink">proveedores</router-link>, son necesarios para utilizar el sistema.</b></p>
          <p style="padding:00px 35px 20px; margin:0; font-size:15px">Pasar una factura de compra es muy fácil y no te va a llevar más de un minuto.
            Si realizas facturas electrónicas, bajate el manual
            <a href="/other/configuracion-inicial-para-hacer-facturas-electronicas-en-qupro.pdf">desde acá</a> y configuralo con tu contador para sincronizarlo con la AFIP.</p>
          <nueva-button>
            <template #actions>
              <router-link :to="nuevaCompraLink">Realizá tu primera compra!</router-link>
            </template>
          </nueva-button>
        </div>
        <div class="col-md-3 visible-md visible-lg">
          <img src="/img/invoice_icon.png">
        </div>
      </div>
    </div>

    <div v-else>
      <!-- FILTROS -->
      <div class="filters-panel">
        <div class="filters-panel__section">
          <div class="filters-panel__section-title">
            <i class="bi bi-search"></i>
            Buscador
          </div>
          <div class="filters-panel__row">
            <div class="filters-panel__field">
              <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar...">
            </div>
            <div class="filters-panel__field">
              <q-select v-model="selectedTypeFilter" :options="typeFilterOptions" />
            </div>
            <div class="filters-panel__field filters-panel__field--inline">
              <label class="control-label">Fecha:</label>
              <Daterange ref="daterange" :opendir="'left'" :initial-start="dateRangeStart" :initial-end="dateRangeEnd" @datepicked="onDatePicked" />
            </div>
            <div class="filters-panel__actions">
              <button type="button" class="filters-panel__btn filters-panel__btn--outline" @click="clearFilters">
                <i class="bi bi-eraser"></i>
                Limpiar filtros
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- TABLA -->
      <div class="data-table">
        <vdtnet-table
          ref="table"
          :fields="fields"
          :opts="opts"
          :selectCheckbox="0"
          container-class-name="table-responsive"
          class-name="table mb-0"
          @purchaseDetail="getPurchaseDetail"
          @cancel="cancelOrDeletePurchase"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import NuevaButton from "../../sub-components/Nueva-button.vue";
import Daterange from "../../global/Daterange-component.vue";
import formatDateMixin from "../../../mixins/formatDateMixin";
import formatMoneyMixin from "../../../mixins/formatMoneyMixin";
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: {
    NuevaButton,
    VdtnetTable,
    Daterange,
    QSelect,
  },
  mixins: [formatDateMixin, formatMoneyMixin],
  data: function () {
    const defaultRange = this.last30DaysRange();
    return {
      selectedTypeFilter: 'all',
      isLoading: false,
      doSearch: "",
      dateRangeStart: defaultRange.startDate,
      dateRangeEnd: defaultRange.endDate,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/purchases/list",
          type: "GET",
          data: (d) => {
            d.filter = this.selectedTypeFilter;
            d.daterange = this.daterange;
            return d;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: false,
        pageLength: 15,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        autoWidth: false,
        order: [[0, "desc"]],
      },
      fields: {
        id: { visible: false },
        type: { label: "Tipo", width: "70px" },
        number: { label: "N°", width: "70px" },
        created_at: {
          label: "Fecha",
          width: "130px",
          searchable: true,
          render: (data) => this.formatoFechaHora(data),
        },
        provider_name: {
          label: "Proveedor",
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data}</span>` : data,
        },
        user: { label: "Usuario", width: "120px" },
        status: {
          label: "Estado",
          width: "110px",
          render: (data, type) => {
            if (type !== 'display') return data;
            if (data === "CANCELED") return '<span class="status-badge status-badge--danger">Anulada</span>';
            if (data === "CONFIRMED") return '<span class="status-badge status-badge--success">Confirmada</span>';
            return `<span class="status-badge status-badge--neutral">${data || 'Desconocido'}</span>`;
          },
        },
        total: {
          label: "Total",
          width: "110px",
          align: "right",
          render: (data, type) => {
            const formatted = this.formatoDinamicoMoneda(data, type);
            return type === 'display' ? `<span class="data-table__primary">${formatted}</span>` : formatted;
          },
        },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "100px",
          align: "right",
          defaultContent: `
            <div class="table-action-group">
              <button data-action="purchaseDetail" class="table-action-btn" type="button" title="Ver detalle">
                <i class="bi bi-file-earmark-text"></i>
              </button>
              <button data-action="cancel" class="table-action-btn" type="button" title="Anular/Eliminar comprobante">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          `,
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.isLoading = true; });
      dt.on('xhr.dt', () => { this.isLoading = false; });
    });
  },
  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === "" && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },
    selectedTypeFilter() {
      this.refreshTable();
    },
    daterange() {
      this.refreshTable();
    },
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    onDatePicked(date) {
      this.dateRangeStart = date.startDate;
      this.dateRangeEnd = date.endDate;
    },
    clearFilters() {
      this.doSearch = '';
      this.selectedTypeFilter = 'all';
      const defaultRange = this.last30DaysRange();
      this.dateRangeStart = defaultRange.startDate;
      this.dateRangeEnd = defaultRange.endDate;
    },
    getPurchaseDetail(data) {
      this.$router.push({
        name: "Detalle de compra",
        params: { purchaseId: data.id },
      });
    },
    cancelOrDeletePurchase(data) {
      const isCanceled = data.status === "CANCELED";
      const url = isCanceled ? "/api/purchases/delete" : "/api/purchases/cancel";
      const message = isCanceled
        ? "¿Está seguro que desea borrar este comprobante?"
        : "¿Está seguro que desea cancelar este comprobante?";
      if (!confirm(message)) return;
      this.$http.post(url, { id: data.id }).then((response) => {
        if (response.data.code === 201) this.refreshTable();
      });
    },
  },
  computed: {
    daterange() {
      if (!this.dateRangeStart || !this.dateRangeEnd) return null;
      return `${this.formatoFecha2Daterange(this.dateRangeStart)} - ${this.formatoFecha2Daterange(this.dateRangeEnd)}`;
    },
    typeFilterOptions() {
      return [
        { value: 'all', label: 'Todos los comprobantes' },
        { value: 'invoices', label: 'Facturas' },
        { value: 'credit-notes', label: 'Notas de crédito' },
        { value: 'debit-notes', label: 'Notas de débito' },
        { value: 'other', label: 'Otros comprobantes' },
        { value: 'deleted', label: 'Comprobantes anulados' },
      ];
    },
    nuevaCompraLink() {
      return { name: "Nueva compra" };
    },
    indexInventarioLink() {
      return { name: "Inventario" };
    },
    indexProveedoresLink() {
      return { name: "Proveedores" };
    },
  },
};
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 4px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 1 1 auto;
  margin-bottom: 0;
}
</style>
